import React, { Component } from 'react';
import './App.css';
import Stories from './components/Stories/Stories'
import Header from './components/Header/Header'

class App extends Component {
  render() {
    return (
      <div className="App">
        <Header />
        <Stories />
        <div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js